module.exports = __webpack_public_path__ + "static/WorkSans-Bold-8fb3be90df8be327314a6c4a09cb32ce.woff";